import React from "react";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-12 py-16">
      <p className="text-[#C9A24B] text-xs tracking-[0.3em] uppercase mb-3 text-center">Notre histoire</p>
      <h1 className="font-serif text-4xl sm:text-5xl text-white text-center mb-8">À propos de MYSE</h1>
      <p className="font-script text-4xl gold-text text-center mb-10">Meet Your Star Exclusively</p>

      <div className="space-y-6 text-[#C4C1B8] leading-relaxed text-lg">
        <p>
          MYSE — <em>Meet Your Star Exclusively</em> — est née d'une conviction simple : chaque événement mérite
          un moment d'exception. Nous rendons accessible ce qui semblait réservé à quelques privilégiés :
          la présence d'un artiste ou d'une personnalité pour votre mariage, votre anniversaire ou votre gala privé.
        </p>
        <p>
          Notre plateforme connecte les particuliers et les entreprises à un réseau exclusif d'artistes du monde entier,
          classés par continent, style et genre musical. Vous choisissez, vous demandez, nous orchestrons.
        </p>
        <p>
          Chaque demande est étudiée avec soin par l'artiste et son management. De la première prise de contact
          à la prestation finale, l'équipe MYSE vous accompagne pour transformer votre vision en un souvenir impérissable.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 text-center">
        {[
          ["500+", "Artistes"],
          ["2000+", "Événements"],
          ["98%", "Satisfaits"],
          ["24/7", "Support"],
        ].map(([v, l]) => (
          <div key={l} className="p-6 rounded-2xl border border-white/10 glass">
            <div className="font-serif text-3xl gold-text">{v}</div>
            <div className="text-[#A19E95] text-xs uppercase tracking-wider mt-1">{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
